export default __webpack_public_path__ + "static/media/j33veLight.e798af95.svg";